import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Button, Heading } from "@foris/avocado-suite";
import styles from "./sessionAssignationToolbar.module.scss";

interface SessionAssignationToolbarProps {
  viewSwitch: ReactNode;
  selectedCount: number;
  canDelete: boolean;
  canRestore: boolean;
  canDuplicate: boolean;
  canValidate: boolean;
  busy: boolean;
  onDelete: () => void;
  onRestore: () => void;
  onDuplicate: () => void;
  onValidate: () => void;
  onGoToLeague: () => void;
}

const SessionAssignationToolbar = ({
  viewSwitch,
  selectedCount,
  canDelete,
  canRestore,
  canDuplicate,
  canValidate,
  busy,
  onDelete,
  onRestore,
  onDuplicate,
  onValidate,
  onGoToLeague,
}: SessionAssignationToolbarProps) => {
  const { t } = useTranslation();
  return (
    <header className={styles.toolbar}>
      <div className={styles.left}>
        {viewSwitch}
        <span className={styles.divider} aria-hidden />
        <Heading type="h3">
          {t(`assignation-edit.session-view.${selectedCount === 1 ? "selected-one" : "selected"}`, {
            count: selectedCount,
          })}
        </Heading>
        <div className={styles.actions}>
          <Button
            size="sm"
            variant="ghost"
            leftIcon="trash"
            disabled={busy || !canDelete}
            onClick={onDelete}
          >
            {t("assignation-edit.header.delete")}
          </Button>
          <Button
            size="sm"
            variant="ghost"
            leftIcon="repeat"
            disabled={busy || !canRestore}
            onClick={onRestore}
          >
            {t("assignation-edit.header.restore-changes")}
          </Button>
          <Button
            size="sm"
            variant="ghost"
            leftIcon="copy"
            disabled={busy || !canDuplicate}
            onClick={onDuplicate}
          >
            {t("assignation-edit.header.duplicate")}
          </Button>
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant="ghost" disabled={busy} onClick={onGoToLeague}>
          {t("assignation-edit.header.go-to-league")}
        </Button>
        <Button loading={busy} disabled={!canValidate} onClick={onValidate}>
          {t("assignation-edit.header.validate")}
        </Button>
      </div>
    </header>
  );
};

export default SessionAssignationToolbar;
